import classNames from 'classnames';
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { NavLink, useMatch } from 'react-router-dom';
import ChevronRightSvg from 'images/v5/icons/chevron-right.svg';
import DotsIcon from 'images/v5/icons/dots-vertical.svg';
import FolderOpenedSvg from 'images/v5/icons/folder-opened.svg';
import FolderSvg from 'images/v5/icons/folder.svg';
import Button from 'layout/atoms/Button/Button';
import Checkbox from 'layout/atoms/Checkbox/Checkbox';
import Dropdown from 'layout/atoms/Dropdown/Dropdown';
import FolderOptions from 'layout/molecules/FolderOptions/FolderOptions';
import { selectIsFolderOpened, toggleIsFolderOpened } from 'store/specificationsFoldersSlice';
import { selectIsFolderOpenedMove, selectMoveFolder, setMoveFolder, toggleIsFolderOpenedMove, } from 'store/specificationsMoveSlice';
import styles from './FolderTreeButton.module.scss';
function FolderTreeButton({ node, children, isRoot, isLast, link, disabled = false, withMenu = false, onClick, }) {
    var _a;
    const dispatch = useDispatch();
    const isFolderOpened = useSelector((state) => selectIsFolderOpened(state, node.id));
    const isFolderOpenedMove = useSelector((state) => selectIsFolderOpenedMove(state, node.id));
    const moveFolder = useSelector(selectMoveFolder);
    const folderLink = link || '/specifications/folders';
    const isActive = ((_a = useMatch(`${folderLink}/:folderId`)) === null || _a === void 0 ? void 0 : _a.params.folderId) === node.id;
    const showMenu = withMenu && isActive;
    if (onClick) {
        return (React.createElement("li", { className: classNames(styles.wrap, { [styles.opened]: isFolderOpenedMove }) },
            React.createElement("div", { className: styles.checkboxButton },
                React.createElement(Checkbox, { onClick: () => dispatch(setMoveFolder({ folderId: node.id })), value: moveFolder === node.id, disabled: disabled }),
                React.createElement("button", { type: "button", className: styles.button, onClick: () => {
                        onClick();
                        dispatch(toggleIsFolderOpenedMove({ id: node.id }));
                    } },
                    React.createElement("span", { className: styles.main },
                        React.createElement("span", { className: styles.icon }, isFolderOpenedMove && children ? React.createElement(FolderOpenedSvg, null) : React.createElement(FolderSvg, null)),
                        React.createElement("span", { className: styles.name }, node.name),
                        node.foldersCount > 0 && (React.createElement("span", { className: styles.counter },
                            "(",
                            node.foldersCount,
                            ")"))),
                    node.foldersCount > 0 && (React.createElement("span", { className: styles.chevron },
                        React.createElement(ChevronRightSvg, null))))),
            children));
    }
    return (React.createElement("li", { className: classNames(styles.wrap, {
            [styles.opened]: isFolderOpened,
            [styles.isRoot]: isRoot,
            [styles.isLast]: isLast,
        }) },
        React.createElement("div", { className: styles.row },
            React.createElement(NavLink, { to: `${folderLink}/${node.id}`, title: `${node.name} (${node.foldersCount})` },
                React.createElement("button", { type: "button", className: classNames(styles.button, {
                        [styles.active]: isActive,
                        [styles.withMenu]: showMenu,
                    }), onClick: () => {
                        dispatch(toggleIsFolderOpened({ id: node.id }));
                    } },
                    React.createElement("span", { className: styles.main },
                        React.createElement("span", { className: styles.icon }, isFolderOpened && children ? React.createElement(FolderOpenedSvg, null) : React.createElement(FolderSvg, null)),
                        React.createElement("span", { className: styles.name }, node.name),
                        node.foldersCount > 0 && (React.createElement("span", { className: styles.counter },
                            "(",
                            node.foldersCount,
                            ")"))),
                    node.foldersCount > 0 && (React.createElement("span", { className: styles.chevron },
                        React.createElement(ChevronRightSvg, null))))),
            showMenu && (React.createElement("div", { className: classNames(styles.menu, { [styles.withChevron]: node.foldersCount > 0 }) },
                React.createElement(Dropdown, { trigger: React.createElement(Button, { size: "xs", shape: "rounded", theme: "ghost", leftIcon: React.createElement(DotsIcon, null) }) },
                    React.createElement(FolderOptions, { id: node.id, name: node.name, parentId: node.parentId }))))),
        children));
}
export default FolderTreeButton;
